/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BundleCheckoutResponse } from '../../models/bundle-checkout-response';
import { DeliveryNoteBundlesCheckout } from '../../models/delivery-note-bundles-checkout';
import { KeyType } from '../../models/key-type';

export interface PostDeliveryNoteBundlesCheckout$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
      body: DeliveryNoteBundlesCheckout
}

export function postDeliveryNoteBundlesCheckout(http: HttpClient, rootUrl: string, params: PostDeliveryNoteBundlesCheckout$Params, context?: HttpContext): Observable<StrictHttpResponse<BundleCheckoutResponse>> {
  const rb = new RequestBuilder(rootUrl, postDeliveryNoteBundlesCheckout.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BundleCheckoutResponse>;
    })
  );
}

postDeliveryNoteBundlesCheckout.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-note-bundles-checkout';
